import { SessionStorageEntityIdResolver } from '../../resolvers/session-storage-entityid/session-storage-entityid.resolver';

export const entityPickerRoute = {
  path: 'entity-picker',
  url: '/entity-picker',
  resolve: {
    entityId: SessionStorageEntityIdResolver,
  },
  loadChildren: () => import('../../../shell/entity-picker/entity-picker.module').then(m => m.EntityPickerModule),
};
